export default "__VITE_ASSET__DA_1xG$j__"